export const FETCH_NOTIFICATIONS_BEGIN = "FETCH_NOTIFICATIONS_BEGIN"
export const FETCH_NOTIFICATIONS_SUCCESS = "FETCH_NOTIFICATIONS_SUCCESS"
export const FETCH_NOTIFICATIONS_FAILURE = "FETCH_NOTIFICATIONS_FAILURE"

export const ARCHIVE_NOTIFICATION_BEGIN = "ARCHIVE_NOTIFICATION_BEGIN"
export const ARCHIVE_NOTIFICATION_SUCCESS = "ARCHIVE_NOTIFICATION_SUCCESS"
export const ARCHIVE_NOTIFICATION_FAILURE = "ARCHIVE_NOTIFICATION_FAILURE"

export const FetchNotificationsBegin = () => ({
  type: FETCH_NOTIFICATIONS_BEGIN
})

export const FetchNotificationsSuccess = notifications => ({
  type: FETCH_NOTIFICATIONS_SUCCESS,
  payload: { notifications }
})

export const FetchNotificationsFailure = error => ({
  type: FETCH_NOTIFICATIONS_FAILURE,
  payload: { error }
})

export const ArchiveNotificationBegin = () => ({
  type: ARCHIVE_NOTIFICATION_BEGIN
})

export const ArchiveNotificationSuccess = () => ({
  type: ARCHIVE_NOTIFICATION_SUCCESS
})

export const ArchiveNotificationFailure = error => ({
  type: ARCHIVE_NOTIFICATION_FAILURE,
  payload: { error }
})
